import React, { forwardRef } from "react";
import Icon from "../../../core/components/Icon.tsx";
import RotaItem from "./components/DropdownRotaItem.tsx";
import { userItems } from "./constants/Dropdown.constants.tsx";

interface DropdownUserProps {
  ref: React.RefObject<HTMLDivElement>;
  handleLogoutClick: () => void;
}

const DropdownUser = forwardRef<HTMLDivElement, DropdownUserProps>(
  ({ handleLogoutClick }, ref) => {
    return (
      <div className="dropdown-content-config" ref={ref}>
        <div className="separador-menu-perfil"></div>
        <div className="content-menu-rows">
          <div className="dropdown-content-2" ref={ref}>
            <div style={{ margin: 0 }} className="titulo-navbar-icone">
              <Icon name="User" size="xl" theme="dark" />
              <span className="titulo-navbar-texto">Usuário</span>
            </div>
            {userItems.map((item) => (
              <RotaItem
                key={item.label}
                item={item}
              />
            ))}
            <p className="p-p-p" onClick={handleLogoutClick}>
              Sair
            </p>
          </div>
        </div>
      </div>
    );
  }
);

export default DropdownUser;
